import { useState as i, useEffect as o } from "react";
import { debounce as r } from "lodash-es";
const d = 200;
function u() {
  const [n, e] = i(0);
  return o(() => {
    e(window.innerWidth);
    const t = r(() => {
      e(window.innerWidth);
    }, d);
    return window.addEventListener("resize", t), () => window.removeEventListener("resize", t);
  }, []), {
    width: n
  };
}
export {
  u as default
};
